/**
 * @author rmh
 * 模块说明：退货申请单管理
 */
import { Service } from '@/tools'

export class ReturnApplyService<T extends TProcure.ReturnApply> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.ReturnApply}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   */
  returnPage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：退货申请单详情
   */
  detailById = <K extends T['ApiDetailById']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiDetailById', data)
  }

  /**
   * 模块说明：修改申请单
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiUpdate', data)
  }

  /**
   * 模块说明：新增申请单
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiAdd', data, '操作成功')
  }

  /**
   * 模块说明：关联单据
   */
  relatedOrder = <K extends T['ApiRelatedOrder']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiRelatedOrder', data)
  }

  /**
   * 模块说明：获取可退数
   */
  allowReturnQuantity = <K extends T['ApiAllowReturnQuantity']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiAllowReturnQuantity', data)
  }
}
